import React from "react";

/** The merchant has the flow's page open now (`FlowSummary.on_page`: seen within 30 s). */
const OnThePage: React.FC = () => (
  <span
    role="status"
    className="flex items-center gap-1 rounded-full border border-green-200 bg-green-50 px-1.5 py-0.5 text-[11px] font-medium text-green-800 dark:border-green-900 dark:bg-green-950/40 dark:text-green-200"
  >
    <span aria-hidden className="size-1.5 rounded-full bg-green-500 motion-safe:animate-pulse" />
    On the page
  </span>
);

export default OnThePage;
